import type { FC } from 'react'

import { Radio } from '@skytech/ui'
import { useQuery } from '@tanstack/react-query'
import type { FieldProps } from 'formik'
import { Field } from 'formik'

import { Translation } from '@/app/translations/Translation'
import { useTranslation } from '@/app/translations/translations-hooks'

import queries from '../queries'
import terminationResources from '../resources'
import type { TerminationType } from '../types'

export const NewTerminationType: FC<{ costObjectId: number | null }> = ({ costObjectId }) => {
  const translate = useTranslation()
  const { data: setup } = useQuery(queries.terminationSetup(), terminationResources.getSetup)

  if (!setup || !costObjectId) {
    return null
  }

  const isPrivateNumber = setup.costObjectList.find(co => co.id === costObjectId)?.type === 'E'

  const validTypes: TerminationType[] = ['CANCELLATION', 'USER_DECIDES']

  return (
    <>
      <h3>
        <Translation id="Termination type" />
      </h3>

      {validTypes.map(type => (
        <Field name="terminationType" key={type}>
          {({ field, meta }: FieldProps) => (
            <Radio
              id={type}
              checked={field.value === type}
              label={
                type === 'USER_DECIDES'
                  ? isPrivateNumber
                    ? translate('User is using a private number')
                    : translate('User will decide (use this for regular employee)')
                  : translate(`termination_type/${type}`)
              }
              isDisabled={isPrivateNumber && type === 'CANCELLATION'}
              marginBottom={16}
              error={meta.error}
              touched={meta.touched}
              {...field}
            />
          )}
        </Field>
      ))}
    </>
  )
}
